import React from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

const TermsOfService = () => {
  return (
    <div className="bg-light py-5">
      <Helmet>
        <title>Terms of Service | SpireNest</title>
        <link rel="canonical" href="https://spirenest.co/terms-of-service" />
        <meta name="description" content="Review SpireNest's terms of service governing the use of our website and NetSuite services." />
      </Helmet>
      <Container>
        <div className="max-w-4xl mx-auto">
          <h1 className="mb-4">Terms of Service</h1>

          <p className="mb-4">
            These Terms of Service ("Terms") govern your use of SuiteMatrix's website and services. By accessing or using our services, you agree to be bound by these Terms.
          </p>

          <h2 className="mb-3">Acceptance of Terms</h2>
          <p className="mb-4">
            By accessing and using our website, you accept and agree to be bound by the terms and provision of this agreement.
          </p>

          <h2 className="mb-3">Use License</h2>
          <p className="mb-2">Permission is granted to temporarily download one copy of the materials on SuiteMatrix's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
          <ul className="mb-4">
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose</li>
            <li>Remove any copyright or other proprietary notations</li>
            <li>Transfer the materials to another person</li>
          </ul>

          <h2 className="mb-3">Disclaimer</h2>
          <p className="mb-4">
            The materials on SuiteMatrix's website are provided on an 'as is' basis. SuiteMatrix makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
          </p>

          <h2 className="mb-3">Limitations</h2>
          <p className="mb-4">
            In no event shall SuiteMatrix or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on SuiteMatrix's website.
          </p>

          <h2 className="mb-3">Revisions and Errata</h2>
          <p className="mb-4">
            The materials appearing on SuiteMatrix's website could include technical, typographical, or photographic errors. SuiteMatrix does not warrant that any of the materials on its website are accurate, complete or current.
          </p>

          <h2 className="mb-3">Links</h2>
          <p className="mb-4">
            SuiteMatrix has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by SuiteMatrix of the site.
          </p>

          <h2 className="mb-3">Modifications</h2>
          <p className="mb-4">
            SuiteMatrix may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these Terms of Service.
          </p>

          <h2 className="mb-3">Contact Us</h2>
          <p className="mb-0">
            If you have any questions about these Terms of Service, please contact us at <a href="mailto:support@suitematrix.co">support@suitematrix.co</a>.
          </p>
        </div>
      </Container>
    </div>
  );
};

export default TermsOfService; 